/**
 * It's a generated file, preferable to extend this in external file
 */
import {ServerTypeName} from 'common/enums';
import * as yup from 'common/yup';
import {passphrase} from 'common/yup/customs/passphrase';
import {AbstractServer} from '../Abstract/AbstractServer';
import {serverTypeNameSchema} from '../ServerTypeName';

export const OneDriveNames = {
   typeName: 'typeName',
   clientId: 'clientId',
   clientSecret: 'clientSecret',
   tenantId: 'tenantId',
   email: 'email',
} as const;

export const OneDriveServer = AbstractServer.shape({
   typeName: serverTypeNameSchema.default(ServerTypeName.ONEDRIVE),
   // ServerType: yup.string().oneOf(enums.ServerType).required(),
   [OneDriveNames.clientId]: yup.idString().default(['']),
   [OneDriveNames.tenantId]: yup.idString().default(['']),
   [OneDriveNames.clientSecret]: passphrase(),
   [OneDriveNames.email]: yup.string().email().default(['']),
});
export type IOneDriveServer = yup.InferType<typeof OneDriveServer>;
